/**
 * @file src/api/purchaseCreditNote.api.js
 * @description Vendor credit notes. /purchases/credit-notes
 */

import { apiClient } from "lib/axios";

const normalizeCreditNote = (cn) => {
  if (!cn) return cn;
  return {
    ...cn,
    id: cn.id || cn._id,
    vendorId: cn.vendorId?._id || cn.vendorId?.id || cn.vendorId || "",
    vendorName: cn.vendorName || cn.vendorId?.name || "—",
  };
};

const normalizeListResponse = (data) => {
  const creditNotes =
    data?.creditNotes || data?.data?.creditNotes || data?.data || [];
  return {
    ...data,
    creditNotes: Array.isArray(creditNotes)
      ? creditNotes.map(normalizeCreditNote)
      : [],
  };
};

const normalizeItemResponse = (data) => {
  const creditNote =
    data?.creditNote || data?.data?.creditNote || data?.data || data;
  return { ...data, creditNote: normalizeCreditNote(creditNote) };
};

const buildCleanPayload = (payload) => {
  const clean = {
    documentType: payload.documentType || "operating_expense",
    vendorId: payload.vendorId || null,
    vendorName: payload.vendorName || "",
    billId: payload.billId || null,
    originalBillNumber: payload.originalBillNumber || "",
    documentDate: payload.documentDate,
    reason: payload.reason || "",
    branchId: payload.branchId || null,
    currency: payload.currency || "SAR",
  };

  if (Array.isArray(payload.lineItems) && payload.lineItems.length > 0) {
    clean.lineItems = payload.lineItems;
  } else {
    clean.amount = payload.amount;
    clean.taxRate = payload.taxRate;
    if (payload.accountId) clean.accountId = payload.accountId;
  }

  return clean;
};

export const getPurchaseCreditNotes = async (params = {}) => {
  const { data } = await apiClient.get("/purchases/credit-notes", { params });
  return normalizeListResponse(data);
};

export const getPurchaseCreditNoteById = async (id) => {
  const { data } = await apiClient.get(`/purchases/credit-notes/${id}`);
  return normalizeItemResponse(data);
};

export const createPurchaseCreditNote = async (payload) => {
  const { data } = await apiClient.post(
    "/purchases/credit-notes",
    buildCleanPayload(payload),
  );
  return normalizeItemResponse(data);
};

export const voidPurchaseCreditNote = async (id, body = {}) => {
  const { data } = await apiClient.post(
    `/purchases/credit-notes/${id}/void`,
    body,
  );
  return normalizeItemResponse(data);
};
